const LEVEL_PRIORITY = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
};

const normalizeLevel = level => (level && LEVEL_PRIORITY[level] ? level : 'info');

const envLevel = (() => {
  const explicit = import.meta.env.VITE_LOG_LEVEL?.toLowerCase();
  if (explicit && LEVEL_PRIORITY[explicit]) {
    return explicit;
  }
  return import.meta.env.VITE_DEBUG_LOGS === 'true' ? 'debug' : 'info';
})();

const shouldLog = level => LEVEL_PRIORITY[level] >= LEVEL_PRIORITY[envLevel];

const formatMessage = (scope, messages) =>
  scope ? [`[${scope}]`, ...messages] : messages;

const createLogger = scope => ({
  debug: (...messages) => {
    if (shouldLog('debug')) {
      console.debug(...formatMessage(scope, messages));
    }
  },
  info: (...messages) => {
    if (shouldLog('info')) {
      console.info(...formatMessage(scope, messages));
    }
  },
  warn: (...messages) => {
    if (shouldLog('warn')) {
      console.warn(...formatMessage(scope, messages));
    }
  },
  error: (...messages) => {
    if (shouldLog('error')) {
      console.error(...formatMessage(scope, messages));
    }
  },
  scope: childScope => createLogger(childScope ?? scope),
});

const logger = createLogger();

export default logger;
export const createScopedLogger = scope => createLogger(scope);
